import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const ServiceReminder = gql`
    query ServiceReminder ($id: ID!) {
        serviceReminder (id: $id) {
            id
            serviceTaskTypeKey
            defaultServiceTask {
                id
                name
                serviceTaskTypeKey
                recommendedServiceCycle
            }
            nextDueDate
            lastServiceDate
            update
            typeDefinitionAttributeList {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
